












import { defineComponent } from "@vue/composition-api";

import CvSection from "./cv-section.vue";
import { CvHobbySection } from "@/models";

interface Props {
  hobbies: CvHobbySection;
}

export default defineComponent({
  name: "cv-hobby-section",
  components: { CvSection },
  props: {
    hobbies: { type: Object, required: true }
  },

  setup() {
    return {};
  }
});
